export const QUILL_EDITOR_CONSTS = {
  deleteGalleryConfirmationText: 'удалить галерею из публикации?',
  deleteGalleryConfirmationfirstSentenceText: 'Вы действительно хотите',
  deleteGalleryConfirmBtn: 'Да, удалить',
  maxPublicationLength: 2500,
  mayBeThisArticleMsg: `Новость не должна быть больше 2500. Может это статья?`,
  reachedCharacterLimitMsg: 'Достигнут лимит по кол-ву знаков, статью будет сложно читать',
  unknownMsg: 'Неизвестен'
}
